import React from 'react';

import './styles/privileges.scss';

export const Privileges = (props) => {
  return (
    <div className="card-privileges">
      <h3>Включено в тариф</h3>

      {
        props.subscription ?
          <div>
            <p>Полотенце на время посещения</p>
            <p>Безлимитный доступ {props.milleniumAdded ? 'во все клубы' : 'в три клуба сети'}</p>
            <p>1 гостевой визит ежемесячно</p>
            <p>Тренажерный зал</p>
            <p>Бассейн</p>
            <p>Аквааэробика</p>
            <p>Групповые тренировки</p>
            {props.milleniumAdded ? <p>Анализ состава тела InBody</p> : ''}
            <p>Персональная тренировка с тренером</p>
            <p>Финские сауны и хаммам</p>
            <p>Крутая программа лояльности</p>
          </div> :
          <div>
            {props.towel ? <p>Полотенце на время посещения</p> : ''}
            {props.privileges.smart_start > 0 ? <p>Программа Умный старт / {props.privileges.smart_start}шт</p> : ''}
            {props.privileges.gym_personal_trains > 0 ?
              <p>Персональная тренировка в тренажерном зале / {props.privileges.gym_personal_trains}шт</p> : ''}
            {props.privileges.pool_personal_trains > 0 ?
              <p>Персональная тренировка в бассейне / {props.privileges.pool_personal_trains}шт</p> : ''}
            <p>Групповые тренировки
              от {props.milleniumAdded ? props.millenium_privileges.count_group_trainings : props.privileges.count_group_trainings} уроков
              в день</p>
            {props.privileges.guest_visits > 0 ? <p>Гостевые визиты для друзей / {props.privileges.guest_visits}шт</p> : ''}
            {props.privileges.teen_club_visits > 0 ?
              <p>Teen-клуб 12+ гостевое / {props.privileges.teen_club_visits}шт</p> : ''}
            {props.privileges.loyalty_program ? <p>Программа лояльности</p> : ''}
            {props.privileges.personal_locker ? <p>Персональный шкафчик / сейфовая ячейка на время посещения</p> : ''}
            {props.privileges.solarium_minutes > 0 ? <p>Солярий {props.privileges.solarium_minutes} минут</p> : ''}

            {
              props.testDrive ?
                <div style={{marginTop: '40px'}}>
                  <h3>Условия приобретения</h3>
                  <p>Тест-драйв может приобрести клиент строго 15+</p>
                  <p>Тест-драйв предоставляется только один раз и при предъявлении паспорта</p>
                </div> : ''
            }
          </div>
      }
    </div>
  )
}